// Module
var code = " <record-form-view fields=\"stateController.userFormFields\" model=\"stateController.model\" title=\"\" on-submit=\"stateController.submitUser(formViewController)\" on-cancel=\"stateController.cancel(formViewController)\"> </record-form-view> ";
// Exports
export default code;